import { useEffect, useState } from 'react';
import useClinicProductSuggestions, {
  UseClinicProductSuggestionsReturn
} from '../../../../apis/clinic-products/hooks/useClinicProductSuggestions';
import useClinicProductsForm from '../../../ClinicProduct/hooks/useClinicProductForm';

export function useSuggestedProducts(productsForm: ReturnType<typeof useClinicProductsForm>, masterMedicineId?: string) {
  const clinicProductSuggestions = useClinicProductSuggestions(masterMedicineId);

  useClearResponseOnMasterMedicineChange(clinicProductSuggestions, masterMedicineId);
  usePopulateFormWithProducts(productsForm, clinicProductSuggestions);
  useRemoveProductsOnMasterMedicineChange(productsForm, masterMedicineId);
}

function usePopulateFormWithProducts(
  productsForm: ReturnType<typeof useClinicProductsForm>,
  clinicProductSuggestionsReturn: UseClinicProductSuggestionsReturn
) {
  const { isFetched, clinicProductSuggestions } = clinicProductSuggestionsReturn;

  useEffect(() => {
    const productsInForm = Object.values(productsForm.getValues());

    if (isFetched && !productsInForm.length) {
      productsForm.reset(clinicProductSuggestions);
    }
  }, [productsForm, clinicProductSuggestions, isFetched]);
}

function useRemoveProductsOnMasterMedicineChange(
  productsForm: ReturnType<typeof useClinicProductsForm>,
  masterMedicineId?: string
) {
  useEffect(() => {
    const productsInForm = Object.values(productsForm.getValues());

    if (productsInForm.length) {
      productsForm.reset([]);
    }
  }, [masterMedicineId, productsForm]);
}

function useClearResponseOnMasterMedicineChange(
  clinicProductSuggestionsReturn: UseClinicProductSuggestionsReturn,
  masterMedicineId?: string
) {
  const [currentMedicineId, setCurrentMedicineId] = useState(masterMedicineId);

  useEffect(() => {
    if (masterMedicineId !== currentMedicineId) {
      clinicProductSuggestionsReturn.clearResponse();
      setCurrentMedicineId(masterMedicineId);
    }
  }, [clinicProductSuggestionsReturn, masterMedicineId, currentMedicineId]);
}
